import Vue               from 'vue';
import VueLodash         from 'vue-lodash';
import lodash            from 'lodash';
import Web3              from 'web3';
import BootstrapVue      from 'bootstrap-vue';
import axios             from 'axios';
import moment            from 'moment';
import VueLogger         from 'vuejs-logger';
import VueFloatLabel     from 'vue-float-label';
import VueMeta           from 'vue-meta';
import App               from './App.vue';
import store             from './store';
import VueWebsocket      from 'vue-native-websocket';
import router            from './router';
import i18n              from './libs/i18n';
import Toast             from 'vue-toastification';

import 'vue-toastification/dist/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/fonts/css/all.min.css';
import '@/assets/main.css';

const params = {
    ws: "ws://127.0.0.1:8545",
    http: "http://127.0.0.1:8082",
    wss: "wss://node.evrice.com",
    https: "https://evrice.com",
};

Vue.use(Toast, {
    position: "bottom-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.44,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false
});

Vue.use(VueWebsocket, (process.env.NODE_ENV === 'production' ? "wss://www.evrice.com/v2/transport" : "ws://127.0.0.1:8082/v2/transport"), {
    format              : 'json',
    reconnection        : true,
    reconnectionAttempts: 100,
    reconnectionDelay   : 1000
});

// Websocket crypto node init.
let provider = new Web3.providers.WebsocketProvider(process.env.NODE_ENV === 'production' ? params.wss : params.ws);
Vue.prototype.$web3 = new Web3(provider, {
    headers: {
        Origin: process.env.NODE_ENV === 'production' ? params.https : params.http
    }
});

provider.on('connect', () => {
    setInterval(() => {
        provider = new Web3.providers.WebsocketProvider(process.env.NODE_ENV === 'production' ? params.wss : params.ws);
        Vue.prototype.$web3 = new Web3(provider, {
            headers: {
                Origin: process.env.NODE_ENV === 'production' ? params.https : params.http
            }
        });
    }, 50000);
});

store.dispatch('getLocalStorage', 'token').then((token) => {
    axios.defaults.baseURL = (process.env.NODE_ENV === 'production' ? params.https + "/v2" : params.http + "/v2");
    if (token) {
        axios.defaults.headers.common.Authorization = token;
    }
});

Vue.use(VueMeta, {refreshOnceOnNavigation: true});
Vue.use(VueLodash, {name: 'custom', lodash: lodash});
Vue.use(VueFloatLabel);
Vue.use(VueLogger, {
    isEnabled         : true,
    logLevel          : process.env.NODE_ENV === 'production' ? 'error' : 'debug',
    stringifyArguments: false,
    showConsoleColors : true
});
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

Vue.prototype.$api = async () => {
    return process.env.NODE_ENV === 'production' ? params.https + "/v2" : params.http + "/v2"
};
Vue.prototype.$storage = async (folder,address,name) => {
    if (name !== "" && name !== undefined) {
        return process.env.NODE_ENV === 'production' ? params.https + `/v2/storage/${folder}/${address}/${name}.jpg` : params.http + `/v2/storage/${folder}/${address}/${name}.jpg`;
    } else {
        return '';
    }
};

Vue.filter('formatUnix', function (value) {
    if (value) {
        return moment.unix(value).format('MM-DD-YYYY, h:mm');
    }
});
Vue.filter('formatBytes', function formatBytes(bytes) {
    let marker = 1024, decimal = 3, kiloBytes = marker, megaBytes = marker * marker;
    if (bytes < kiloBytes) return bytes + " bytes"; else if (bytes < megaBytes) return (bytes / kiloBytes).toFixed(decimal) + " kb";
});
Vue.filter('numberFormat', function (number, decimalCount = 0, decimal = ".", thousands = ",", sufix = "") {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    const negativeSign = number < 0 ? "-" : "";
    let i = parseInt(number = Math.abs(Number(number) || 0).toFixed(decimalCount)).toString(),
        j = (i.length > 3) ? i.length % 3 : 0;
    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(number - i).toFixed(decimalCount).slice(2) : "") + (sufix ? sufix : "");
});
Vue.filter('namegr', function (name) {
    if (name !== undefined) {
        let double = name.split(" ").map(item => item.trim());
        if (double.length > 1) {
            return double[0][0] + double[1][0]
        } else {
            let count = name.length / 2;
            return name.substring(0,count|0)[0] + name.substring(count|0)[0];
        }
    } else {
        return "";
    }
});
Vue.filter('base64', (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let result = "";
        reader.readAsDataURL(file);
        reader.onload = () => {
            result = reader.result;
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.onloadend = () => {
            resolve(result);
        };
    });
});

new Vue({
    store,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
